// extracted by mini-css-extract-plugin
export default {"addButton":"addButton_addButton__6AnOW"};